import cn from "classnames";
import React from "react";
import { useIntl } from "react-intl";
import "./IntegrationActionButton.scss";

interface Props {
  isActive: boolean;
  onClick: () => void;
}

export function IntegrationActionButton({ isActive, onClick }: Props) {
  const intl = useIntl();

  return (
    <button
      type="button"
      className={cn("integration-connect-btn", {
        "integration-connect-btn--connected": isActive,
      })}
      onClick={onClick}
    >
      <span className="integration-connect-btn__label">
        {!isActive
          ? intl.formatMessage({ id: "app.home.syncUp" })
          : intl.formatMessage({ id: "app.home.disconnect" })}
      </span>
    </button>
  );
}
